import {HttpsCallable, HttpsCallableOptions, httpsCallable} from 'firebase/functions';
import {useMemo} from 'react';
import {useFunctions} from 'reactfire';

export function useHttpsCallableFunction<RequestData = unknown, ResponseData = unknown>(
  name: string,
  options?: HttpsCallableOptions,
): HttpsCallable<RequestData, ResponseData> {
  const functions = useFunctions();
  const optionsKey = JSON.stringify(options ?? {});
  return useMemo(() => {
    const opts = JSON.parse(optionsKey) as HttpsCallableOptions;
    return httpsCallable<RequestData, ResponseData>(functions, name, Object.keys(opts).length > 0 ? opts : undefined);
  }, [functions, name, optionsKey]);
}
